export function throttle (fn, wait) {
  let last = 0
  let timer = null

  const run = () => {
    last = Date.now()
    timer = null
    fn()
  }

  return () => {
    const remaining = wait - (Date.now() - last)

    if (remaining <= 0) {
      clearTimeout(timer)
      run()
      return
    }

    timer ??= setTimeout(run, remaining)
  }
}
